import { ExtendedFeatureCollection, geoMercator, geoPath } from 'd3-geo'

export interface ScaleAndProjection {
  scale: number
  translate: [number, number]
}

export const getScaleAndProjection = (
  features: ExtendedFeatureCollection,
  width: number,
  height: number
): ScaleAndProjection => {
  // Create a unit projection.
  const projection = geoMercator().scale(1).translate([0, 0])
  // Create a path generator.
  const path = geoPath().projection(projection)
  // Compute the bounds of a feature of interest, then derive scale & translate.
  const b = path.bounds(features)

  const scale =
    0.95 / Math.max((b[1][0] - b[0][0]) / width, (b[1][1] - b[0][1]) / height)

  // XXX we need to multiply by the width and height because nivo multiply this translation: https://github.com/plouc/nivo/blob/master/packages/geo/src/hooks.js#L57
  const translate: [number, number] = [
    Math.round(
      ((width - scale * (b[1][0] + b[0][0])) / 2 / width + Number.EPSILON) *
        1000
    ) / 1000,
    Math.round(
      ((height - scale * (b[1][1] + b[0][1])) / 2 / height + Number.EPSILON) *
        1000
    ) / 1000,
  ]

  // Update the projection to use computed scale & translate.
  return { scale, translate }
}

export const describeArc = (
  x: number,
  y: number,
  radius: number,
  startAngle: number,
  endAngle: number,
  invert = false
) => {
  const start = polarToCartesian(x, y, radius, startAngle)
  const end = polarToCartesian(x, y, radius, endAngle)

  const largeArcFlag = Math.abs(endAngle - startAngle) <= 180 ? '0' : '1'

  const d = [
    'M',
    start.x,
    start.y,
    'A',
    radius,
    radius,
    0,
    largeArcFlag,
    invert ? 0 : 1,
    end.x,
    end.y,
  ].join(' ')

  return d
}

export const polarToCartesian = (
  centerX: number,
  centerY: number,
  radius: number,
  angleInDegrees: number
) => {
  const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0

  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians),
  }
}
